import debugConstructor from 'debug'

import * as elements from '../elements'

import { applyDisplayObjectProps } from './props'
import TYPES from './types'

const debug = debugConstructor('reconciler')

const ELEMENTS = Object.keys(TYPES).reduce(
  (res, type) => ((res[type] = elements[TYPES[type]]), res), // eslint-disable-line no-sequences
  {},
)

/**
 * Create an element based on tag type
 * Similar to react-dom's `React.createElement()`
 *
 * @param {string} type Element type
 * @param {Object} props Component props
 * @param {Object} root Root instance
 * @returns {PIXI.*|undefined}
 */
export function createInstance(type, props = {}, root = null) {
  debug('createInstance', type, props)
  const fn = ELEMENTS[type]
  let element

  if (typeof fn === 'function') {
    element = fn(root, props)
  }

  // apply initial props!
  if (element) {
    element.displayName = type
    let { applyProps } = element
    if (typeof applyProps !== 'function') {
      applyProps = applyDisplayObjectProps
    }
    applyProps(element, {}, props)
  }

  return element
}

export function arrangeViews(instance) {
  let { parent } = instance
  while (parent) {
    if (typeof parent.arrangeChildren === 'function') {
      parent.arrangeChildren()
    }
    parent = parent.parent
  }
}

export function registerElement(type, createInstance) {
  ELEMENTS[type] = createInstance
}
